import { DialogUtility } from '@syncfusion/ej2-popups';


function EditDocumentAbortDialog(title: string, message: string) {

    DialogUtility.alert({
        title: title,
        content: message,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' }
    });

}
export default EditDocumentAbortDialog;